
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    var $head = $(".job-detail-intro__head");
    var $background = $(".job-detail-intro__background");        
    var $topic = $head.find(".job-detail-intro__topic");
    var $title = $head.find(".job-detail-intro__title");

    

    // after images are loaded or window is rezised
    $(window).on('load resize', function () {
        var isBelowMd = $(".kit-indicator--md").is(":hidden");
        var offset = isBelowMd ? 60 : 140;
        var height = $topic.outerHeight(true) + $title.outerHeight(true);
        $background.css("top", (height + offset) + "px");        
    });

})(window, document, jQuery);
